import Masonry from "masonry-layout";
import scrollMonitor from "scrollmonitor";

// Drag functionality for the timeline and navigation
const DragContainer = (container) => {
  let pos = { top: 0, left: 0, x: 0, y: 0 };
  container.style.cursor = "grab";

  const mouseDownHandler = function (e) {
    container.style.cursor = "grabbing";
    container.style.userSelect = "none";

    pos = {
      left: container.scrollLeft,
      top: container.scrollTop,
      x: e.clientX,
      y: e.clientY,
    };

    document.addEventListener("mousemove", mouseMoveHandler);
    document.addEventListener("mouseup", mouseUpHandler);
  };

  const mouseMoveHandler = function (e) {
    const dx = e.clientX - pos.x;
    const dy = e.clientY - pos.y;
    container.scrollTop = pos.top - dy;
    container.scrollLeft = pos.left - dx;
  };

  const mouseUpHandler = function () {
    container.style.cursor = "grab";
    container.style.removeProperty("user-select");
    document.removeEventListener("mousemove", mouseMoveHandler);
    document.removeEventListener("mouseup", mouseUpHandler);
  };

  container.addEventListener("mousedown", mouseDownHandler);
};

// Initialize ScrollMonitor, Masonry, and DragContainer
const timeline = document.querySelector(".about-timeline .dates");

if (timeline) {
  const timelineNav = document.querySelector(".about-timeline nav ul");
  const timelineNavLinks = timelineNav.querySelectorAll("li");

  // ScrollMonitor tracking for active sections
  const sections = document.querySelectorAll(".year");
  const watchers = [];

  sections.forEach((section, index) => {
    const watcher = scrollMonitor.create(section, -20); // Create watcher with offset

    watcher.enterViewport(() => {
      // Remove 'active' class from all nav items
      timelineNavLinks.forEach((link) => link.firstElementChild.classList.remove("active"));

      // Add 'active' class to the corresponding button
      if (timelineNavLinks[index]) {
        timelineNavLinks[index].firstElementChild.classList.add("active");
      }
    });

    watchers.push(watcher);
  });

  // Handle click events for navigation buttons
  timelineNavLinks.forEach((item) => {
    item.addEventListener("click", (event) => {
      const link = item.firstElementChild;
      const scrollTo = document.getElementById(link.dataset.href);
      scrollToElm(timeline, scrollTo, 300); // Scroll to the section
    });
  });

  // Handle Masonry grid layout
  let windowWidth = window.innerWidth;
  let masonryOptions;

  const updateMasonryOptions = () => {
    if (windowWidth >= 1280) {
      masonryOptions = {
        itemSelector: ".grid-item",
        columnWidth: ".date",
        percentPosition: true,
        gutter: 50,
      };
    } else {
      masonryOptions = {
        itemSelector: ".grid-item",
        columnWidth: ".date",
        percentPosition: true,
        gutter: 20,
      };
    }
  };

  updateMasonryOptions();

  DragContainer(timeline);
  DragContainer(timelineNav);

  let EventsGrid;

  window.onload = () => {
    timeline.classList.add("active");
    if (windowWidth >= 768) {
      EventsGrid = new Masonry(timeline, masonryOptions);
    }
  };

  // Handle window resize
  window.addEventListener(
    "resize",
    () => {
      windowWidth = window.innerWidth;
      updateMasonryOptions();

      if (windowWidth >= 768) {
        if (!EventsGrid) {
          EventsGrid = new Masonry(timeline, masonryOptions);
        }
      } else if (EventsGrid) {
        EventsGrid.destroy();
        EventsGrid = null;
      }
    },
    true
  );

  // Scroll to section within the container
  function scrollToElm(container, elm, duration) {
    const pos = getRelativePos(elm);
    scrollTo(container, pos.top, duration / 1000);
  }

  function getRelativePos(elm) {
    const pPos = elm.parentNode.getBoundingClientRect(); // parent position
    const cPos = elm.getBoundingClientRect(); // element position
    const pos = {
      top: cPos.top - pPos.top + elm.parentNode.scrollTop,
    };

    return pos;
  }

  function scrollTo(element, to, duration, onDone) {
    const start = element.scrollTop;
    const change = to - start;
    const startTime = performance.now();

    function animateScroll() {
      const now = performance.now();
      const elapsed = (now - startTime) / 1000;
      const t = elapsed / duration;

      element.scrollTop = start + change * easeInOutQuad(t);

      if (t < 1) {
        window.requestAnimationFrame(animateScroll);
      } else if (onDone) {
        onDone();
      }
    }

    animateScroll();
  }

  function easeInOutQuad(t) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
  }
}
